import React from 'react';
import { useNavigate } from 'react-router-dom';

const Dashboard = () => {
    const navigate = useNavigate();
    const userStr = localStorage.getItem('user');
    const user = userStr ? JSON.parse(userStr) : null;

    if (!user) {
        return <div className="container mt-5 text-center" style={{minHeight: "50vh"}}><h2>Please login to view your dashboard</h2></div>;
    }

    const logout = () => {
        localStorage.removeItem('user');
        window.location.href = '/home'; // Forces reload to clear header state easily
    };

    return (
        <div className="container mt-5 mb-5 p-4 rounded shadow-sm bg-white" style={{minHeight: "50vh"}}>
            <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-3">
                <h2 style={{color: "#263238"}}>Welcome, {user.fullName}!</h2>
                <button className="btn btn-outline-danger" onClick={logout}>Logout</button>
            </div>
            <div className="card p-4 shadow-sm" style={{border: "none", backgroundColor: "#f9f9f9"}}>
                <h4 className="mb-3" style={{color: "#4fbf9f"}}>Profile Details</h4>
                <div className="row">
                    <div className="col-md-6 mb-2">
                        <p><strong>Name:</strong> <span className="ms-2">{user.fullName}</span></p>
                    </div>
                    <div className="col-md-6 mb-2">
                        <p><strong>Email:</strong> <span className="ms-2">{user.email}</span></p>
                    </div>
                    <div className="col-md-6 mb-2">
                        <p><strong>Mobile:</strong> <span className="ms-2">{user.mobileNumber}</span></p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;
